export default __webpack_public_path__ + "static/m-topshot-fc89ff3a7bfe3f784b0c46bfe960f7a6.png";